import validate from 'validate.js';
import get from 'lodash/get';

import * as Modules from '@/modules';
import ModalModules from '@/modules/modals';
import isObject from '@/helpers/isObject';
import extendMetadata from '@/helpers/extendMetadata';
import getMetadataFields from '@/helpers/getMetadataFields';

class InstanceValidator {
  constructor({ instance, isModal, isEnabledParams }) {
    this.isEnabledParams = isEnabledParams;
    this.data = {};
    this.constraints = {};
    this.instance = instance;

    const moduleList = isModal ? ModalModules : Modules;

    const module = moduleList[instance.module];
    const instanceMetadata = extendMetadata(module.metadata);
    const allFields = getMetadataFields(instanceMetadata);
    this.metaDataKeyValue = {};

    allFields.forEach(({ name }) => {
      this.metaDataKeyValue[name] = this.instance.data[name];
    });

    // TODO: refact me pls!!
    if (instanceMetadata.tabs) {
      const visibleTabs = instanceMetadata.tabs.filter(
        InstanceValidator.isVisible.bind(this),
      );

      visibleTabs.forEach(InstanceValidator.validateFields.bind(this));
    } else {
      instanceMetadata.groups
        .filter(InstanceValidator.isVisible.bind(this))
        .forEach(InstanceValidator.validateFields.bind(this));
    }
  }

  // Deve conter apenas Groups OU Fields
  // Ex modelPath: 0-2/subject (Tab 0 / Group 2 / Field subject)
  static validateFields({ groups, fields }, parentIndex) {
    if (fields) {
      fields
        .filter(InstanceValidator.isVisible.bind(this))
        .forEach(
          ({
            validation,
            name: fieldName,
            value,
            fields: nestedFields = [],
          }) => {
            const model = this.instance.data[fieldName];

            if (isObject(validation)) {
              const groupModelPath = `${parentIndex}/${fieldName}`;
              const escapedGroupModelPath = groupModelPath.replace(
                /\./g,
                '\\.',
              );

              this.data[groupModelPath] = value || model;

              if (
                this.data[groupModelPath] &&
                typeof this.data[groupModelPath] === 'object' &&
                typeof this.data[groupModelPath].value !== 'undefined'
              ) {
                this.data[groupModelPath] = this.data[groupModelPath].value;
              }

              this.constraints[escapedGroupModelPath] = validation;
            }

            if (nestedFields.length && Array.isArray(model)) {
              model.forEach((fieldData, fieldDataIndex) => {
                const realData = Object.entries(fieldData).map(
                  ([fieldDataName, fieldDataValue]) => ({
                    ...nestedFields.find(({ name }) => name === fieldDataName),
                    value: fieldDataValue,
                    name: `${fieldName}.${fieldDataIndex}.${fieldDataName}`,
                    parentName: `${fieldName}.${fieldDataIndex}`,
                  }),
                );

                InstanceValidator.validateFields.call(
                  this,
                  { fields: realData },
                  parentIndex,
                );
              });
            }
          },
        );
    } else if (groups) {
      const visibleGroups = groups.filter(
        InstanceValidator.isVisible.bind(this),
      );

      visibleGroups.forEach((group, index) => {
        InstanceValidator.validateFields.call(
          this,
          group,
          `${parentIndex}-${index}`,
        );
      });
    }
  }

  static isVisible({ isEnabled = () => true, parentName } = {}) {
    if (parentName) {
      const model = get(this.metaDataKeyValue, parentName);

      return isEnabled.call(model, {
        ...this.metaDataKeyValue,
        ...this.isEnabledParams,
        instance: this.instance,
      });
    }

    return isEnabled({
      ...this.metaDataKeyValue,
      ...this.isEnabledParams,
      instance: this.instance,
    });
  }

  validate() {
    let isValid = true;

    const messages = validate(this.data, this.constraints, {
      fullMessages: false,
    });

    this.messages = {};

    if (isObject(messages)) {
      this.messages = messages;

      isValid = false;
    }

    return isValid;
  }

  getMessages() {
    return this.messages;
  }
}

export default InstanceValidator;
